import { Button, CircularProgress } from '@mui/material';
import propTypes from 'prop-types';
import React from 'react';

function AttendanceActionBtn({ label, isLoading, isDisabled, variant, color, size, className, onClick }) {
  return (
    <Button
      startIcon={isLoading ? <CircularProgress size={20} /> : undefined}
      disabled={isDisabled || isLoading}
      variant={variant}
      color={color}
      size={size}
      className={className}
      onClick={onClick}
    >
      {label}
    </Button>
  );
}

AttendanceActionBtn.propTypes = {
  label: propTypes.string.isRequired,
  isLoading: propTypes.bool,
  isDisabled: propTypes.bool,
  variant: propTypes.string,
  color: propTypes.string,
  size: propTypes.string,
  className: propTypes.string,
  onClick: propTypes.func,
};

AttendanceActionBtn.defaultProps = {
  isLoading: false,
  isDisabled: false,
  variant: 'contained',
  color: 'primary',
  size: 'medium',
  className: undefined,
  onClick: () => {},
};

export default AttendanceActionBtn;
